<template>
	<div style="margin-top: 0px;">

		<!-- 3.使用组件 -->
		<!-- 页头 -->
		<roheader></roheader>
		<!-- 内容 -->

	<el-dialog title="开票失败" :visible.sync="invoiceDialog" width="50%" v-loading='loading' :before-close="close_error_dialog">
					<div
						style="background-color: #fcdede;padding:0 15px;color:black;float: left;margin-bottom: 10px;;padding: 20px;width: 100%;">
						<div style="text-align: left;">订单编号:{{fail_order_name}}</div>
						<div style="text-align: left;">错误原因:{{fail_message}}</div>
							<div style="text-align: left;">错误码:{{fail_code}}</div>
						</div>
						<div>
						<div style="text-align: left;">解决办法：</div>
						<div style="text-align: left;">1.电话联系13761553206，并报订单号与错误码</div>
						<div  style="text-align: left;">2. 24小时后到“个人中心->开具发票”页面重新开票</div>
						<div  style="text-align: left;">办公时间：上午8:30-12:00,下午1:30-5:00(节假日及双休日除外)</div>
					</div>
					<span slot="footer" class="dialog-footer">
						<!-- <el-button @click="close_error_dialog">取消</el-button> -->
						<el-button type="danger" @click="close_error_dialog()">关闭</el-button>
					</span>
				</el-dialog>
				
		<el-dialog title="开具发票" :visible.sync="dialogVisible" width="50%" v-loading='loading'>
			<!-- 	<h3>开票金额</h3>
			<h5 style="color:red">600.00元</h5> -->
			<div
				style="background-color: #fcdede;padding:0 15px;color:black;float: left;margin-bottom: 10px;;padding: 20px;width: 100%;">
				<div style="text-align: left;">1. 电子发票与纸质发票具有同等法律效力，提交后30分钟内可开具。</div>
				<div  style="text-align: left;">2. 申请开票后，您可以在开票记录页面自助查询历史开票记录，并下载电子发票。</div>
				
		
			</div>
				<div style="float: left;font-size: 18px;color:black">开票主体：内蒙古自治区健康促进与教育协会，金额 </div>
				<div style="color: red;float: left;font-weight: bold;font-size: 18px;">￥{{order_info.total_fees}}</div>
				
				
			<div style="width:100%;border:2px dotted #cdcdcd;padding:20px;overflow: hidden;">
			
				<el-radio-group v-model="account_selected" style="width: 100%;" @change="select_account($event)">
					<el-radio border class="ro-address-radio" v-for="(account_data, index) in account_datas"
						:key="index" :label="account_data.name">
						<span style="width: 100%;" :data-id="account_data.id">{{account_data.unit_name}}</span>
						<div style="width: 100%;" :data-id="account_data.id" class="ro-box-content">
							{{account_data.tax_number}}
						</div>
					</el-radio>
				</el-radio-group>
				<el-row style='text-align: center'>
					<a>
						<el-button style="margin-top: 20px;background: red;color:white;" @click="turn_to_invoice_new">
							新增发票信息
						</el-button>
					</a>
				</el-row>
		
			</div>
			<el-form>
				<div style="overflow: hidden;margin-top:20px;">
					<!-- <el-form-item label="单位名称" style="float: left;width: 25%;margin-right: 5%">
						<el-input v-model="account_unit_name"></el-input>
					</el-form-item>
					<el-form-item label="纳税人识别号" style=";float: left;width: 25%;;margin-right: 5%">
						<el-input v-model="account_tax_number"></el-input>
					</el-form-item>
					<el-form-item label="发票接收邮箱" style=";float: left;width: 25%;;margin-right: 5%">
						<el-input v-model="account_receive_email"></el-input>
					</el-form-item> -->
					<el-form-item  style=";float: left;margin-right: 5%">
						<div style="float: left;">备注:</div>
						<div style="float: left;margin-left: 10px;"><el-input style="float: left;" type=""  v-model="note"  ></el-input></div>
						
					</el-form-item> 
					<div style="float: left;line-height: 40px;">建议不要超过25个汉字或50个（数字+字母），否则盖章的时候有可能压到。</div>
				</div>
			</el-form>
		
		
			<span slot="footer" class="dialog-footer">
				<el-button @click="close_dialog">取消</el-button>
				<el-button type="primary" @click="confirm_create_invoice()">确定</el-button>
			</span>
		</el-dialog>
		

		<div style="width:100%;background: #F1F1F1;overflow: auto;padding-bottom: 30px;">
			<div style="width:1200px;margin:auto;padding:20px;">
				<rosidebar></rosidebar>
				<div
					style="float: right;width:calc(100% - 269px);overflow: hidden;min-height:1090px;background: white;border-radius: 5px;">
					<h6 style="border-bottom: 1px solid #F1F1F1;line-height: 70px;text-align: left;padding-left: 20px;">
						{{order_info.type}}{{order_info.name}}

					</h6>
					<div style="width: 90%;margin:20px auto;">
						<el-steps :active="state" align-center finish-status="success">
							<el-step title="审核中"></el-step>
							<el-step title="查新中"></el-step>
							<el-step title="完成"></el-step>
						</el-steps>
					</div>
					<div class="ro-states-box" style="background-color: #f0f0f0;height: 100px;">
						<div style="height:46px;line-height: 46px;padding: 30px;">
							<div class="el-icon-warning-outline" style="color:dodgerblue;font-size: 46px;float: left;">
							</div>
							<div style="color:#333;font-size: 18px;font-weight: 800;margin-left:10px;float: left;">
								当前状态：{{order_info.state}}</div>

							<el-button type="warning" v-if="order_info.invoice_state=='no_invoice'" @click="create_invoice"
								style="float: right;margin-left: 10px;">开具发票</el-button>
								
							<el-button type="warning" v-if="order_info.invoice_state=='invoicing'" 
								style="float: right;margin-left: 10px;">开票中</el-button>
								
							<el-button type="primary" @click="download_url()" v-if="order_info.invoice_download_url"
								style="float: right;margin-left: 10px;">下载发票</el-button>
							<el-button type="primary" @click="download_pdf()"
								v-if="order_info.pdf_url&&order_info.type!='SCI查收'"
								style="float: right;margin-left: 10px;">下载报告</el-button>
							<!-- <a v-if='order_info.pdf_url' :href='order_info.pdf_url'>下载报告</a> -->
						</div>
					</div>
					<div class="ro-states-box" style="margin-top: 20px;overflow: hidden;">
						<div style="float: right;width: 48%;border-radius: 5px;height:200px;background-color: #f8f8f8"
							v-if="order_info.invoice_download_url">
							<div class="ro-states-box-title">
								开票信息
							</div>
							<div style="color:gray;font-size: 13px;padding:20px;">
								<div>发票类型：<span style="color:#333;font-weight: 500;">增值税普通发票</span></div>
								<div>单位名称：<span style="color:#333;font-weight: 500;">{{order_info.account_unit_name}}</span>
								</div>
								<div>纳税人识别号：<span
										style="color:#333;font-weight: 500;">{{order_info.account_tax_number}}</span>
								</div>
								<!-- <div>发票接收邮箱：<span
										style="color:#333;font-weight: 500;">{{order_info.account_email}}</span></div> -->
							</div>
						</div>
						<div style="float: left;width: 48%;border-radius: 5px;height:200px;background-color: #f8f8f8">
							<div class="ro-states-box-title">
								支付信息
							</div>
							<div style="color:gray;font-size: 13px;padding:20px;">
								<div>总金额：<span style="color:#333;font-weight: 500;">¥{{order_info.total_fees}}</span>
								</div>
								<div>支付方式：<span style="color:#333;font-weight: 500;">{{order_info.pay_type}}</span>
								</div>
								<div>支付时间：<span style="color:#333;font-weight: 500;">{{order_info.pay_date}}</span>
								</div>
								<!-- <div>首次支付¥：<span style="color:#333;font-weight: 500;">0.00</span></div>
								<div>首次在线支付：<span style="color:#333;font-weight: 500;">否</span></div>
								<div>补费金额¥：<span style="color:#333;font-weight: 500;">0.00</span></div> -->
							</div>
						</div>
					</div>
					<div
						style="border: 1px solid #cdcdcd;border-radius: 5px;width: 90%;margin:20px auto;padding:20px;overflow-y: auto;">
						<div style="text-align: left;color:#333;font-weight: 800;">委托单信息</div>
						<el-collapse v-model="activeNames" style="margin-top: 20px;">
							<el-collapse-item title="一、基本信息" name="1">
								<div style="overflow: hidden;">
									<div style="float:left">订单编号：</div>
									<div style="float:left;margin-left:20px;color:gray;font-weight: 400;">
										{{order_info.code}}
									</div>
								</div>

								<div style="overflow: hidden;">
									<div style="float:left">项目名称：</div>
									<div style="float:left;margin-left:20px;color:gray;font-weight: 400;">
										{{order_info.name}}
									</div>
								</div>

								<div style="overflow: hidden;">
									<div style="float:left">单位名称：</div>
									<div style="float:left;margin-left:20px;color:gray;font-weight: 400;">
										{{order_info.unit_name}}
									</div>
								</div>
								
								<div style="overflow: hidden;">
									<div style="float:left;width: 76px">委托人：</div>
									<div style="float:left;margin-left:8px;color:gray;font-weight: 400;">
										{{order_info.contact}}
									</div>
								</div>
								<div style="overflow: hidden;">
									<div style="float:left;width: 76px">手机号：</div>
									<div style="float:left;margin-left:8px;color:gray;font-weight: 400;">
										{{order_info.contact_mobile}}
									</div>
								</div>

							</el-collapse-item>
							<el-collapse-item title="二、查新内容" name="2" v-if="order_info.type=='科技查新'">
								<div style="overflow: hidden;" v-if='order_info.type=="科技查新"'>
									<div style="float:left">查新范围：</div>
									<div style="float:left;margin-left:20px;color:gray;font-weight: 400;">
										{{order_info.scope_string}}
									</div>
								</div>
								<div style="overflow: hidden;" v-if='order_info.type=="科技查新"'>
									<div style="float:left">课题级别：</div>
									<div style="float:left;margin-left:20px;color:gray;font-weight: 400;">
										{{order_info.topic_type_string}}
									</div>
								</div>
								<div style="overflow: hidden;" v-if='order_info.type=="科技查新"'>
									<div style="float:left">项目类型：</div>
									<div style="float:left;margin-left:20px;color:gray;font-weight: 400;">
										{{order_info.project_type_string}}
									</div>
								</div>
								<div style="overflow: hidden;">
									<div style="text-align: left;float:left">创新点及技术要点：</div>
									<div style="text-align: left;float:left;margin-left:20px;color:gray;font-weight: 400;">
										{{order_info.science_tech_key_point}}
									</div>
									<!-- <div style="margin-left:20px;color:gray;font-weight: 400;text-align: left;">
										研究内容:主要技术内容、规格、特征、参数、指标、新旧对比、应用范围、国内外背景等</div>
									<div
										style="border:1px solid #F1F1F1;border-radius: 5px;margin:20px;padding:20px;text-align: left;color:gray;">
										{{order_info.science_tech_key_point}}
									</div> -->
								</div>
								<div style="overflow: hidden;">
									<div style="float:left">参考检索词：</div>
									<div style="float:left;margin-left:20px;color:gray;font-weight: 400;">
										{{order_info.search_term}}
									</div>
								</div>

								<div style="overflow: hidden;">
									<div style="text-align: left;float:left">主要参考文献：</div>
									<div style="float:left;margin-left:20px;color:gray;font-weight: 400;">
										{{order_info.reference_string}}
									</div>

								</div>

							</el-collapse-item>
							</el-collapse-item>
							<el-collapse-item title="二、查引内容" name="2" v-if="order_info.type=='科技查引'">
								<div style="overflow: hidden;">


									<div v-for="(data, index) in reference_ids" :key="index"
										style='width: 100%; border: 2px dotted rgb(205, 205, 205); padding: 20px; overflow: hidden;margin-top: 20px;'>
										<el-form label-width="130px" class="demo-ruleForm">
											<div style="
										font-size: 28px;
										background-color: #f5f7fa;
										width: 50px;border-radius: 50%;">{{index+1}}</div>
											<el-form-item label="查引范围:" prop="title">
												<el-radio disabled v-model="data.scope" label="home">国内</el-radio>
												<el-radio disabled v-model="data.scope" label="abroad">国外
												</el-radio>
											</el-form-item>
											<el-form-item label="题目:" prop="author">
												<el-input type="textarea" disabled v-model="data.title"
													placeholder="题目" />
											</el-form-item>
											<el-form-item label="作者:" prop="author">
												<el-input type="textarea" disabled v-model="data.author"
													placeholder="作者" />
											</el-form-item>
											<el-form-item label="来源出版物:" prop="author">
												<el-input type="textarea" disabled v-model="data.source"
													placeholder="来源出版物" />
											</el-form-item>

										</el-form>
									</div>
								</div>



							</el-collapse-item>
							<el-collapse-item title="二、SCI查收内容" name="2" v-if="order_info.type=='SCI查收'">
								<div style="overflow: hidden;">
									<div v-for="(data, index) in reference_ids" :key="index"
										style='width: 100%; border: 2px dotted rgb(205, 205, 205); padding: 20px; overflow: hidden;margin-top: 20px;'>
										<el-form label-width="130px" class="demo-ruleForm">

											<div style="
																					font-size: 28px;
																					background-color: #f5f7fa;
																					width: 50px;border-radius: 50%;">{{index+1}}</div>
											<el-form-item label="题目:" prop="author">
												<el-input type="textarea" disabled v-model="data.title"
													placeholder="题目" />
											</el-form-item>
											<el-form-item label="作者:" prop="author">
												<el-input type="textarea" disabled v-model="data.author"
													placeholder="作者" />
											</el-form-item>
											<el-form-item label="来源出版物:" prop="author">
												<el-input type="textarea" disabled v-model="data.source"
													placeholder="来源出版物" />
											</el-form-item>

										</el-form>
										<el-button  v-if='order_info.pdf_url' type="primary" @click="download_sci_pdf(data)"
											style="float: right;">下载报告</el-button>
									</div>
								</div>


							</el-collapse-item>




							<el-collapse-item title="三、报告" name="3" v-if='order_info.type!="SCI查收"'>
								温馨提示：仅支持线上自取报告！
								<a v-if='order_info.pdf_url' :href='order_info.pdf_url'>下载报告</a>
							</el-collapse-item>
							<el-collapse-item title="四、附件" name="4" v-if='order_info.attachment_name'>
								<div style="overflow: hidden;">
									<!-- <el-tag effect="plain" v-if="order_info.attachment_name!=''"
										:disable-transitions="false" @click="get_file()">
										{{order_info.attachment_name}}
									</el-tag> -->
									点击下载/查看附件：
									<a :href='order_info.attachment_url'>{{order_info.attachment_name}}</a>
								</div>
								<div style="overflow: hidden;text-align: left;" v-if='!order_info.attachment_url'>
									<div>未上传附件</div>
								</div>
							</el-collapse-item>
						</el-collapse>
					</div>




					<!-- <el-button style="margin-top: 12px;" @click="next">下一步</el-button> -->
				</div>

			</div>
		</div>
		<!-- 页脚 -->
		<rofooter></rofooter>
	</div>

</template>



<script>
	import {
		fetchGet,
		fetchPost
	} from "../utils/request"
	import qs from 'qs'
	// 1.导入组件
	import roheader from "./components/ro_header.vue";
	import rofooter from "./components/ro_footer.vue";
	import rosidebar from "./components/ro_sidebar.vue";
	export default {
		name: 'user_order_infor',
		data() {
			return {
				activeNames: ['1', '2', '3', '4'],
				states: ['审核中', '查新中', '已完成'],
				state: 1,
				order_info: {
					'code': '',
					'name': '',
					'report_date': '',
					'searcher_name': '',
					'state': '',
					'total_fees': '',
					'type': '',
					'unit_name': '',
					'attachment_name': '',
					'attachment_url': '',
				},
				reference_ids: [],
				dialogVisible: false,
				invoiceDialog:false,
				fail_code:'',
				fail_order_name:'',
				fail_message:'',
				account_unit_name: '',
				account_tax_number: '',
				account_receive_email: '',
				account_selected: '',
				loading: false,
				account_datas: [],
				note: '',
			}
		},
		mounted() {
			this.get_order_info()
			this.get_account_data()
			//第一个对比供应商信息加载
		},
		components: {
			// 2.注册局部组件
			roheader,
			rofooter,
			rosidebar,

		},
		methods: {
			download_sci_pdf(data) {
				var url = data.pdf_url
				console.log(url)
				window.open(url, "_blank");
			},
			create_invoice() {

				this.dialogVisible = true
			},
			select_account(e) {

				var id = e
				var select_account_data = this.account_datas.filter(item => item.id == id)[0]


			},
			get_invoice_state(){
				var self =this
				var data = {
					'serial_no':this.serial_no
				}
				fetchPost('/ro/connect/get_invoice_state/v1', data).then(response => {
					console.log(response.data)
					if (response.data.state == 'success') {
						
						clearInterval(self.timer)
						self.invoice_done()
				
					}
					if (response.data.state == 'draft') {
						
						console.log('还未回调，继续查询')
									
					}
					if (response.data.state == 'fail') {
						
					
						clearInterval(self.timer)
						self.$message({
							message: '发票申请失败,请重新尝试开票',
							type: 'error'
						});
						self.fail_code = response.data.fail_code
						self.fail_order_name = response.data.fail_order_name
						self.fail_message = response.data.fail_message
						self.dialogVisible = false
						self.loading = false
						self.invoiceDialog = true
						return
						}
				})		
			},
			invoice_done() {
				var self = this
				self.$message({
					message: '发票申请成功,可在开票记录中下载',
					type: 'success'
				});
				self.dialogVisible = false
				self.loading = false
				this.get_order_data()
				window.location.href = '#/user/invoice'
			},
			confirm_create_invoice() {
				if (this.account_selected == '') {
					this.turn_to_invoice_new()
					return
				}
				// debugger
				// debugger
				var data = {
					'account_id': this.account_selected,
					'order_ids': JSON.stringify([this.$route.query.id]),
					'note': this.note,
		
				}
				console.log(data)
				var self = this
				this.loading = true
				fetchPost('/ro/connector/huisuiyun/create_invoice_async/v1', data).then(response => {
					// console.log(response)
					// debugger
					if (response.data.state != 'success') {
						self.$message({
							message: '发票申请失败,请重新尝试开票',
							type: 'error'
						});
						self.fail_code = response.data.fail_code
						self.fail_order_name = response.data.fail_order_name
						self.fail_message = response.data.fail_message
						self.dialogVisible = false
						self.loading = false
						self.invoiceDialog = true
						return
					}
					self.$message({
						message: '发票申请成功,开票完成后可在开票记录中下载',
						type: 'success'
					});
					self.dialogVisible = false
					self.loading = false
					// this.get_order_data()
					window.location.href ='#/user/invoice_list'
					// var timer = setInterval(function() {
					// 	console.log('循环查询开票情况')
					// 	self.get_invoice_state()

					// }, 3000)
					// self.timer = timer

					// self.serial_no = response.data.serial_no



				})
			},
			// confirm_create_invoice() {
			// 	if(this.account_selected==''){
			// 		this.turn_to_invoice_new()
			// 		return
			// 	}
			// 	var data = {
			// 		'account_id': this.account_selected,
			// 		'order_ids': JSON.stringify([this.order_info.id]),
			// 		'note': this.note,
			// 	}
			// 	console.log(data)
			// 	var self = this
			// 	this.loading = true
			// 	fetchPost('/ro/connector/huisuiyun/create_invoice_async/v1', data).then(response => {
			// 		// 	console.log(response)
			// 		if(response.data!='success'){
			// 			self.$message({
			// 				message: '发票申请失败,请重新尝试开票',
			// 				type: 'error'
			// 			});
			// 			self.fail_code = response.data.fail_code
			// 			self.fail_order_name = response.data.fail_order_name
			// 			self.fail_message = response.data.fail_message
			// 			self.dialogVisible = false
			// 			self.loading = false
			// 			self.invoiceDialog = true
			// 			return 
			// 		}
					
			// 		self.$message({
			// 			message: '发票申请成功,可在开票记录中下载',
			// 			type: 'success'
			// 		});
			// 		self.dialogVisible = false
			// 		self.loading = false
			// 		self.$router.push('/user/invoice_list')
			// 		// location.reload()
			// 		// 	self.account_datas = response.data.list

			// 	})
			// },

			close_dialog() {
				this.dialogVisible = false
			},
			close_error_dialog(){
				this.invoiceDialog = false
			},
			get_account_data() {
				// debugger
				var data = {
					id: window.localStorage.getItem('user_id')
				}
				var self = this
				fetchPost('/ro/tec_search/invoice/list/v1', data).then(response => {
					console.log(response)
					debugger
					if(response.data.result=='session_expired'){
						window.location.href='/#/pages/login'
					}
					self.account_datas = response.data.list
					var account_selected = response.data.list.filter(item => item.default == true)
					if (account_selected.length > 0) {
						self.account_selected = account_selected[0].id
					}

				})
			},
			turn_to_invoice_new() {
				this.$router.push('/user/invoice_new')
			},

			download_url() {
				var url = this.order_info.invoice_download_url
				window.open(url, "_blank");
			},
			download_pdf() {
				if (this.order_info.type == 'SCI查收') {
					this.$message.warning('sci查收请单独下载每一篇报告')
					return
				}
				var url = this.order_info.pdf_url
				window.open(url, "_blank");
			},
			get_order_info() {
				var self = this
				var id = this.$route.query.id
				var data = {
					'id': id,
				}
				fetchPost('/ro/tec_search/order/detail/v1', data).then(response => {
					// debugger
					// var order_info = JSON.parse(window.localStorage.getItem('now_click_order_info'))
					if(response.data.result=='session_expired'){
						window.location.href='/#/pages/login'
					}
					
					var order_info = response.data.data
					console.log(order_info)
					// debugger
					if (order_info.type == '科技查新') {
						self.reference_ids = order_info.reference_ids
					} else {
						self.reference_ids = JSON.parse(order_info.reference_ids)
					}
					self.order_info = order_info
					console.log(order_info.state)
					self.state = self.states.indexOf(order_info.state) + 1

				})

				// if(this.order_info)
			}
		}
	}
</script>
<style>
	@import url("../static/css/css2.css");
	@import url("../static/css/app.min.css");
	@import url("../static/css/fontawesome.min.css");
	@import url("../static/css/animate.min.css");
	@import url("../static/css/style.css");

	#app {
		margin-top: 0px !important;
	}

	.el-step__title {
		font-size: 14px;
	}

	.ro-states-box {
		width: 90%;
		margin: auto;
		border-radius: 5px;
		text-align: left;
	}

	.ro-states-box-title {
		width: 100%;
		height: 50px;
		background-color: #f0f0f0;
		border-top-left-radius: 5px;
		border-top-right-radius: 5px;
		line-height: 50px;
		color: #333333;
		font-weight: 800;
		padding-left: 20px;
		font-size: 14px;
	}

	.el-collapse-item__header {
		background-color: #cdcdcd;
		border-top-left-radius: 3px;
		border-top-right-radius: 3px;
		height: 35px;
		padding: 0 10px;
		font-weight: 800;
	}

	.el-collapse-item__wrap {
		background-color: white;
		padding: 10px;
		font-weight: 800;
		padding-bottom: 0px !important;
	}

	.ro-address-radio {
		width: 31%;
		white-space: normal;
		height: 100px !important;
		float: left;
		text-align: left;
		border: 2px solid #cdcdcd !important;
		margin-left: 1% !important;
		margin-right: 1% !important;
	}
</style>